<template>
  <div>
    <component-editing-header :component="component"
                              :disable-remove="isSelectedComponent || disableToolbarButtons"
                              :disable-moveto="isSelectedComponent || disableToolbarButtons"
                              :disable-add="!isSelectedComponent || disableToolbarButtons"
                              v-on='$listeners' />
        
    <div v-if='component.quickAnimate'>
      <div v-for='group in groupedQuickTweens' :key='group.group' class="pbc-category-main">
        <div class="pbc-category-title">{{group.group}}</div>
        <div class="flex-col">
          <button :class="quicktweenClasses(quickTween)" v-for='quickTween in group.quickTweens' :key='quickTween.name' @click='toggleQuicktween(quickTween)' >
            {{quickTween.name}}
          </button>
        </div>
      </div>

      <div class="pbc-category-main">
        <div class="pbc-category-title">Settings</div>
          <property-form :schema='dbentry.quicktweenSchema'
                        :model='component'
                        :transform='transform'
                        :partutil='partutil'
                        :transforms-and-source="transformsAndSource"
                          v-on='$listeners' />
      </div>
    </div>

    <property-form v-else
                   :schema='dataSchema'
                   :model='component'
                   :transform='transform'
                   :partutil='partutil'
                   :transforms-and-source="transformsAndSource"
                   v-on='$listeners' />

   <toggle-switch class="text-sm h-16 mb-8" v-model='component.quickAnimate' label='Use Presets' />
  </div>
</template>
<script>
import { toPairs, groupBy } from 'lodash';
import ToggleSwitch from '@ui/atoms/ToggleSwitch.vue';
import ComponentEditingHeader from '@ui/molecules/ComponentEditingHeader.vue';
import EditingComponentMixin from '@components/editingComponentMixin.js';
import availableQuicktweens from '@edit/tree/quicktweens.js';

export default {
  mixins: [EditingComponentMixin],
  data() {
    const groupedQuickTweens = toPairs(groupBy(availableQuicktweens, 'group')).map( ([group,quickTweens]) => {
      return {
        group,
        quickTweens
      }
    });
    console.log('GROUPED IT', groupedQuickTweens);
    return {
      quicktweens: [],
      availableQuicktweens,
      groupedQuickTweens
    }
  },
  methods: {
    isSelected(quickTween) {
      return this.component.tweens.find( (tween) => {
        return tween.name === quickTween.name;
      });
    },
    quicktweenClasses(quickTween) {
      const classes = ["m-1 p-1 text-sm font-semibold leading-snug tracking-tight rounded"];
      if (this.isSelected(quickTween)) {
        classes.push('bg-green-500 text-white border-2 border-white');
      } else {
        classes.push('bg-gray-200 border border-gray-400 text-gray-700');
      }
      return classes;
    },
    toggleQuicktween(quickTween) {
      if (!this.isSelected(quickTween)) {
        // find other tweens with same group, and disable them
        this.component.tweens = this.component.tweens.filter( (tween) => {
          const tweenGroup = this.availableQuicktweens.find( (qt) => {
            return qt.name === tween.name;
          });
          if (tweenGroup) {
            return tweenGroup.group !== quickTween.group;
          } else {
            return false;
          }
        });

        this.component.tweens.push(quickTween);
      } else {
        this.component.tweens = this.component.tweens.filter( (tween) => {
          return tween.name !== quickTween.name;
        });
      }
    }
  },
  components:{
    ComponentEditingHeader,
    ToggleSwitch
  }
}
</script>
